// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1qs2_","error":"Textarea_error__18WBL","readonly":"Textarea_readonly__2jDUr","disabled":"Textarea_disabled__2PCgp"};